import {
  ASSET_CREATE_CONTACT_EMAIL,
  ASSET_CREATE_CONTACT_PHONE,
} from '../constants/assetCreateContactDefaults';

/** Shared Offizz listing contact on every asset (form drafts and create submit). */
export function applyAssetCreateContactDefaults(body: Record<string, unknown>): Record<string, unknown> {
  return {
    ...body,
    email: ASSET_CREATE_CONTACT_EMAIL,
    phone_number: ASSET_CREATE_CONTACT_PHONE,
  };
}
